require('./vsko-alert.css');

var vskoAlert = angular.module('vskoAlert', []);

vskoAlert.directive('vskoAlert', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-alert.html'),
    replace: false,
    transclude: {
      toolbarSlot: '?vskoButtonToolbar'
    },
    scope: {
      type: "@",
      dismissible: "="
    },
    link: function($scope, element, attrs) {
      'use strict';

      $scope.getStyleClass = function() {
        var styles = [];

        if ($scope.type) {
          styles.push('alert-' + $scope.type);
        }

        if ($scope.dismissible) {
          styles.push('alert-dismissible');
        }

        if (element.find('vsko-button-toolbar').length > 0) {
          styles.push('alert-has-toolbar');
        }
        return styles.join(" ");
      };
    }
  }
}]);
